import { render, staticRenderFns } from "./NewTextNotification.vue?vue&type=template&id=7d13e726&scoped=true&"
import script from "./NewTextNotification.vue?vue&type=script&lang=js&"
export * from "./NewTextNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewTextNotification.vue?vue&type=style&index=0&id=7d13e726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13e726",
  null
  
)

export default component.exports